import React from 'react';
import { useNavigate } from 'react-router-dom';
interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'accent' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
  icon?: React.ReactNode;
  iconPosition?: 'left' | 'right';
  demo?: boolean;
}
const Button = ({
  children,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  icon,
  iconPosition = 'left',
  className = '',
  demo = false,
  onClick,
  ...props
}: ButtonProps) => {
  const navigate = useNavigate();
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    //navigate('/demo/sukuk-initiation')
    onClick?.(e);
  };
  const baseStyles = 'rounded font-medium transition-colors duration-200 flex items-center justify-center';
  const variantStyles = {
    primary: 'bg-primary text-white hover:bg-primary-dark',
    secondary: 'bg-secondary text-white hover:bg-secondary-dark',
    accent: 'bg-accent text-white hover:bg-accent-dark',
    outline: 'border border-primary text-primary hover:bg-primary hover:text-white',
    ghost: 'text-primary hover:bg-neutral-50'
  };
  const sizeStyles = {
    sm: 'px-3 py-1 text-sm',
    md: 'px-4 py-2',
    lg: 'px-6 py-3 text-lg'
  };
  const widthStyles = fullWidth ? 'w-full' : '';
  return <button className={`${baseStyles} ${variantStyles[variant]} ${sizeStyles[size]} ${widthStyles} ${className}`} onClick={handleClick} {...props} data-id="element-66">
      {icon && iconPosition === 'left' && <span className="mr-2" data-id="element-67">{icon}</span>}
      {children}
      {icon && iconPosition === 'right' && <span className="ml-2" data-id="element-68">{icon}</span>}
    </button>;
};
export default Button;